export * from './iterator/is-async-iterator.js';
export * from './iterator/is-iterator.js';
